import { __decorate } from "tslib";
import { AutoEncoder, StringDecoder, field } from '@simonbackx/simple-encoding';
export class UitpasClientIdAndSecret extends AutoEncoder {
    static get placeholderClientSecret() {
        return '••••';
    }
}
__decorate([
    field({ decoder: StringDecoder })
], UitpasClientIdAndSecret.prototype, "clientId", void 0);
__decorate([
    field({ decoder: StringDecoder })
], UitpasClientIdAndSecret.prototype, "clientSecret", void 0);
//# sourceMappingURL=UitpasClientIdAndSecret.js.map